import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductCategory, Products, ProductSubCategory, ProductType } from '../models/cdn.model';
import {
    BlockMasterList,
    DistrictMasterList,
    GeoMap,
    PanchayatMasterList,
    StatesMasterList,
    VillageMasterList
} from '../models/geo.model';

const cdnHost = 'https://cdn.lokos.in';
const cdnMasterData = `${cdnHost}/lokos-masterdata`;

@Injectable({
    providedIn: 'root'
})
export class CdnService {
    constructor(private http: HttpClient) {}

    getStateLists() {
        const url = `${cdnMasterData}/statemaster.json`;
        return this.http.get<StatesMasterList[]>(url);
    }

    getDistrictLists(stateId: string | number) {
        const state = `${stateId}`.padStart(2, '0');
        return this.http.get<DistrictMasterList[]>(`${cdnMasterData}/state/${state}.json`);
    }

    getBlockLists(stateId: string | number, districtId: string | number) {
        const state = `${stateId}`.padStart(2, '0');
        return this.http.get<BlockMasterList[]>(`${cdnMasterData}/state/${state}/district/${districtId}.json`);
    }

    getPanchayatLists(stateId: string | number, districtId: string | number, blockId: string | number) {
        const state = `${stateId}`.padStart(2, '0');
        return this.http.get<PanchayatMasterList[]>(
            `${cdnMasterData}/state/${state}/district/${districtId}/block/${blockId}.json`
        );
    }

    getVillageLists(
        stateId: string | number,
        districtId: string | number,
        blockId: string | number,
        panchayatId: string | number
    ) {
        const state = `${stateId}`.padStart(2, '0');
        return this.http.get<VillageMasterList[]>(
            `${cdnMasterData}/state/${state}/district/${districtId}/block/${blockId}/panchayat/${panchayatId}.json`
        );
    }

    getGeoMap() {
        return this.http.get<GeoMap[]>(`${cdnHost}/keycloak/geo-map.json`);
    }

    getProducts() {
        return this.http.get<Products[]>(`${cdnHost}/gramudyamita/products.json`);
    }

    getProductCategory() {
        return this.http.get<ProductCategory[]>(`${cdnHost}/gramudyamita/productCategory.json`);
    }

    getProductSubCategory() {
        return this.http.get<ProductSubCategory[]>(`${cdnHost}/gramudyamita/productSubCategory.json`);
    }

    getProductType() {
        return this.http.get<ProductType[]>(`${cdnHost}/gramudyamita/productType.json`);
    }
}
